const CAMPAIGN_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;
export type CampaignAttribution = Partial<Record<typeof CAMPAIGN_KEYS[number], string>> & { landingPath?: string };
let campaign: CampaignAttribution = {};

export function parseCampaign(search: string, pathname: string): CampaignAttribution {
  const params = new URLSearchParams(search);
  const result: CampaignAttribution = {};
  for (const key of CAMPAIGN_KEYS) {
    const value = params.get(key)?.trim();
    // Campaign labels only: never forward arbitrary query strings or contact details.
    if (value && value.length <= 120 && /^[a-zA-Z0-9 _.-]+$/.test(value)) result[key] = value;
  }
  if (Object.keys(result).length) result.landingPath = pathname.slice(0, 200);
  return result;
}

export function getCampaignAttribution(): CampaignAttribution {
  if (typeof window === "undefined") return {};
  const current = parseCampaign(window.location.search, window.location.pathname);
  if (Object.keys(current).length) campaign = current;
  return { ...campaign };
}

export function campaignDestination(href: string) {
  if (typeof window === "undefined") return href;
  const url = new URL(href, window.location.origin);
  if (url.origin !== "https://app.envelaro.com") return href;
  const attribution = getCampaignAttribution();
  for (const key of CAMPAIGN_KEYS) if (attribution[key]) url.searchParams.set(key, attribution[key]);
  return url.toString();
}
